<!--
 * @Description: 销售线索 - 添加页面
 * @Author: mdb
 * @Date: 2022-07-06 11:38:04
 * @LastEditTime: 2022-11-23 16:44:49
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm ref="detailFormRef" type="add" isEdit v-model:value="dataForm" :resetValue="initForm" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
</script>
<script lang="ts">
export default { name: 'DcCosFbuSalesClueAdd' }
</script>

<style lang="scss" scoped></style>
